var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 4.125a1 1 0 0 1 1 1v11.586l5.293-5.293.076-.068a1 1 0 0 1 1.407 1.406l-.069.076-7 7a1 1 0 0 1-.329.218l-.03.01q-.027.012-.057.021l-.05.013-.048.012-.024.004a1 1 0 0 1-.169.015q-.089 0-.173-.016-.011-.002-.022-.003-.024-.005-.047-.012l-.05-.013q-.03-.009-.058-.02l-.03-.01-.048-.023a1 1 0 0 1-.279-.196l-7-7-.068-.076A1 1 0 0 1 5.63 11.35l.076.068L11 16.711V5.125a1 1 0 0 1 1-1"
  })));
};
export default Svg24;